import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Button from '@/components/Button';
import { useTranslation } from '@/hooks/translation';
import styles from './billing-status.module.scss';

export default function BillingStatus(props) {
  const { last4, pastDue, onPayPastDue, onEditPaymentMethod } = props;

  const { t } = useTranslation();

  const buttonText = pastDue ? t('premium.billing.pay_now') : t('premium.billing.edit_payment');

  function handleClick() {
    if (pastDue) {
      onPayPastDue();
    } else {
      onEditPaymentMethod();
    }
  }

  return (
    <>
      <div className='d-flex w-100 justify-content-between'>
        <h4 className={styles.ctaTitle}> {t("user.profile.payment_cta_title")} </h4>
        <Button onClick={handleClick} className={cx(styles.editCta, {[styles.hideEdit]: pastDue})}>{buttonText}</Button>
      </div>

      <div className={cx(styles.statusRow, { [styles.pastDue]: pastDue })}>
        <div>
          <div className='d-flex align-items-center mb-2'>
            <span className={cx(styles.infoRow, "mt-2")}>{t('premium.billing.billing')}</span>
            <span className={cx(styles.last4, "mt-2")}>...{last4}</span>
          </div>
        </div>

        {pastDue && (
          <div className={styles.pastDueContainer}>
            <div className={styles.leftcol}>
              <p className={cx(styles.pastDueMessage)}>{t('premium.past_due.status_message')}</p>
            </div>
            <div className={styles.rightCol}>
              <p onClick={onPayPastDue} className={cx(styles.payNowCta)}>{buttonText}</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

BillingStatus.propTypes = {
  last4: PropTypes.string.isRequired,
  pastDue: PropTypes.bool,
  onPayPastDue: PropTypes.func.isRequired,
  onEditPaymentMethod: PropTypes.func.isRequired,
};
